import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings/styling';

export const carInfoSummaryStyling: CarInfoSummaryStyleParts = {
  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: '8px',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  headerText: {
    display: 'flex',
    gap: '4px',
  },
  durationText: { fontWeight: 'normal' },
  costsContainer: {
    display: 'flex',
    gap: '4px',
  },
  recentCost: {},
  previousCost: {
    color: paletteBase.neutral400,
    textDecoration: 'line-through',
    textDecorationColor: paletteBase.neutral400,
    fontWeight: 'normal',
  },
  infoMessage: {},
};

export const checkoutMobileCommonStyles: AbgSxProps = {
  fontSize: '14px !important',
};

export const checkoutMobileWrapper: AbgSxProps = {
  marginRight: 0,
};

type CarInfoSummaryStyleParts = {
  wrapper: AbgSxProps;
  textContainer: AbgSxProps;
  headerText: AbgSxProps;
  durationText: AbgSxProps;
  costsContainer: AbgSxProps;
  recentCost: AbgSxProps;
  previousCost: AbgSxProps;
  infoMessage: AbgSxProps;
};
